import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";

export const Lightbox = ({ item, onClose }) => {
  useEffect(() => {
    if (!item) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [item, onClose]);

  return (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[100] bg-[#2E1B16]/95 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
          onClick={onClose} role="dialog" aria-modal="true" aria-label={item.title || "Media"} data-testid="lightbox"
        >
          <button onClick={onClose} aria-label="Close" data-testid="lightbox-close" className="absolute top-5 right-5 w-11 h-11 rounded-full border border-[#FAF7F2]/25 text-[#FAF7F2] grid place-items-center hover:border-[#38BDF8] hover:text-[#38BDF8] transition-colors">
            <X size={18} />
          </button>
          <motion.div
            initial={{ scale: 0.96, y: 12 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.98, y: 8 }} transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative max-h-full flex flex-col items-center"
          >
            {item.kind === "video" ? (
              <video src={item.src} poster={item.poster} controls autoPlay playsInline className="max-h-[80vh] max-w-full rounded-sm bg-black" data-testid="lightbox-video" />
            ) : (
              <img src={item.src} alt={item.alt || item.title || ""} className="max-h-[80vh] max-w-full rounded-sm" />
            )}
            {(item.category || item.caption || item.credit || item.instagram_url) && (
              <div className="mt-5 text-center">
                {item.category && <p className="label-eyebrow text-[#38BDF8]">{item.category}</p>}
                {item.caption && <p className="mt-1.5 font-accent text-xl text-[#FAF7F2]/85">{item.caption}</p>}
                {(item.credit || item.instagram_url) && (
                  <p className="mt-3 text-sm text-[#FAF7F2]/55 flex items-center justify-center gap-3">
                    {item.credit && <span data-testid="lightbox-credit">Made for {item.credit}</span>}
                    {item.instagram_url && (
                      <a href={item.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="lightbox-instagram" className="inline-flex items-center gap-1 text-[#38BDF8] hover:text-[#FAF7F2] transition-colors">
                        View on Instagram <ArrowUpRight size={14} />
                      </a>
                    )}
                  </p>
                )}
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Lightbox;
